module.exports = __webpack_public_path__ + "img/super-rare-name.5a5bc118.png";